import React from "react";

import { getAdminMode } from "EmployeeApplication/api";
import { basicInformationURL, isRenewal } from "EmployeeApplication/urls";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import employeeHashId from "Utils/employeeHashID";

import BodyText from "Cobalt/BodyText";

const MissingZipCode = () => {
  const isAdmin = useSelector(getAdminMode);
  return (
    <>
      <BodyText componentClass="p" size="large">
        You must enter your home zip code before selecting a plan.
      </BodyText>
      <BodyText componentClass="p" size="large">
        <Link to={basicInformationURL(isAdmin, isRenewal(), employeeHashId())}>Click here to enter your home zip code.</Link>
      </BodyText>
    </>
  );
};

export default MissingZipCode;
